import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Text, ActionButton } from "@react-spectrum/s2";
import { Visibility, VisibilityOff } from '../icons/s2';
import { isSecretField } from './utils';
const FIELD_LABEL_ACRONYMS: Record<string, string> = {
    ai: 'AI',
    api: 'API',
    byom: 'BYOM',
    css: 'CSS',
    dita: 'DITA',
    docx: 'DOCX',
    faq: 'FAQ',
    html: 'HTML',
    id: 'ID',
    js: 'JS',
    json: 'JSON',
    llm: 'LLM',
    mcp: 'MCP',
    oauth: 'OAuth',
    ootb: 'OOTB',
    pdf: 'PDF',
    sso: 'SSO',
    toc: 'TOC',
    url: 'URL',
    zip: 'ZIP'
};
function formatFieldLabel(label: string): string {
    return label.trim().split(/\s+/).map((word, index)=>{
        const normalized = word.toLowerCase();
        const acronym = FIELD_LABEL_ACRONYMS[normalized];
        if (acronym) return acronym;
        return index === 0 ? normalized.charAt(0).toUpperCase() + normalized.slice(1) : normalized;
    }).join(' ');
}
export interface FieldCardProps {
    label: string;
    value?: string | null;
    isSecret?: boolean;
}
export function FieldCard({ label, value, isSecret }: FieldCardProps) {
    const { t } = useTranslation();
    const [showSecret, setShowSecret] = useState(false);
    const displayValue = value ?? '-';
    const shouldMask = isSecret || isSecretField(label);
    return (<div className="cc-field-card">
      <Text UNSAFE_className="cc-field-label">{formatFieldLabel(label)}</Text>
      <div className={"cc-field-value-container" + " sd171 eb171 _Ce171"}>
        <Text UNSAFE_className="cc-field-value">
          {shouldMask && !showSecret ? '••••••••••••••••••••••••••••••••••••••••' : displayValue}
        </Text>
        {shouldMask && displayValue !== '-' && (<ActionButton isQuiet onPress={()=>setShowSecret(!showSecret)} aria-label={showSecret ? t('commandCenter.fieldCard.hideSecret') : t('commandCenter.fieldCard.showSecret')} UNSAFE_className="cc-field-toggle-btn">
            {showSecret ? <VisibilityOff size="XS"/> : <Visibility size="XS"/>}
          </ActionButton>)}
      </div>
    </div>);
}
export function renderConfigFields(config: Record<string, unknown>) {
    return Object.entries(config).map(([key, val])=>(<FieldCard key={key} label={key.replace(/_/g, ' ')} value={val === null || val === undefined ? '-' : String(val)}/>));
}

import "macro-502cebdcc97dea5b0ad33fb1b48026f8d37161d6262f2072188b60f199390b15.css";